import { render, staticRenderFns } from "./ApproveApplicationFormBlock.vue?vue&type=template&id=bf243946&"
import script from "./ApproveApplicationFormBlock.vue?vue&type=script&lang=js&"
export * from "./ApproveApplicationFormBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports